import s from './style.module.scss';
import MyIcon from '@/components/MyIcon';
import { CheckCircleFilled } from '@ant-design/icons';
import { Tooltip, Checkbox } from 'antd';
import { useEffect, useState } from 'react';
import { Display } from '@/components/Display/Display';
import { Hide } from '@/components/Hide';
import { getCorrespondLabel } from '@/utils/global';
import GrtMobileButton from '@/components/Mobile/GrtButton';
import GrtWebButton from '@/components/Web/GrtButton';
import { getEnvironment, envMap } from '@/utils/Mobile';
import { inject, observer } from 'mobx-react';

import Result from './Result';

const env = getEnvironment();
const AddInfo = (props) => {
    const { sessionStore, chatStore } = props.store;
    const { changeOriginMsgMap, getCurSessionMsgs, currentSessionMapId } = sessionStore;

    const { createRequestByMsgId } = chatStore;
    const [expand, setExpand] = useState(true);
    const [selected, setSelected] = useState([]);
    const { intelligent_qa_clarification, intelligent_qa_status, messageInfo, isSubmit } = props;
    const { options = [], question, selected_value, subtitle } = intelligent_qa_clarification;
    //修改数据，主要是为了发送消息的时候判断流程是否结束，是否可以发送消息
    //需要把currentSessionId传过来 避免切换会话时会话id已经改变 但是请求结果正好回来 导致数据错乱
    const changeData = (data, currentSessionId) => {
        let msgs = getCurSessionMsgs();
        console.log(msgs, 'msgs');
        let len = msgs.length;

        if (len) {
            msgs[len - 1].intelligent_qa_result.intelligent_qa_clarification.selected_value = selected || [];
        }
        changeOriginMsgMap({
            [currentSessionId]: {
                messages: msgs
            }
        });
    };
    const toggleExpand = () => {
        setExpand(!expand);
    };
    const onChange = (e) => {
        setSelected(e);
    };
    const onSubmit = () => {
        const data = {
            selected_options: selected
        };
        let reqData = {
            originQuestion: messageInfo?.question,
            question: JSON.stringify(data),
            tenant_id: messageInfo?.tenant_id,
            user_id: messageInfo?.user_id,
            agent_id: messageInfo?.agent_id,
            skill_id: messageInfo?.skill_id,
            session_id: messageInfo?.session_id,
            interrupt: true
        };
        setExpand(false);
        changeData(reqData, currentSessionMapId);
        createRequestByMsgId(messageInfo?._id || messageInfo?.temId, reqData); //历史记录去id，新消息去临时temId
        console.log(reqData, 'reqData', messageInfo);
    };
    useEffect(() => {
        setSelected(selected_value || []);
        if (selected_value?.length > 0) {
            setExpand(false);
        }
    }, [selected_value]);
    return (
        <div className={s['add-info-wrap']}>
            <div>{question}</div>
            <div className={s['info-content']}>
                <div className={s['group-title']}>
                    <div className={s['left']}>
                        <MyIcon type="icon-add-info"></MyIcon>
                        <span className={s['text']}>
                            补充信息
                            <Display show={selected_value}>
                                <span className={s['icon']}>
                                    <CheckCircleFilled style={{ color: '#52C41A' }} />
                                </span>
                            </Display>
                        </span>
                    </div>

                    <span className={s['expand']} onClick={toggleExpand}>
                        <Display show={!expand}>
                            <Tooltip title="展开">
                                <div>
                                    <MyIcon type="icon-zhankai"></MyIcon>
                                </div>
                            </Tooltip>
                        </Display>
                        <Display show={expand}>
                            <Tooltip title="收起">
                                <div>
                                    <MyIcon type="icon-shouqi"></MyIcon>
                                </div>
                            </Tooltip>
                        </Display>
                    </span>
                </div>
                <Hide show={expand}>
                    <div className={s['subtitle']}>{subtitle}</div>
                    <div className={s['checkbox-group-wrap']}>
                        <Checkbox.Group onChange={onChange} className={s['checkbox-group']} disabled={selected_value} value={selected}>
                            {options.map((item, index) => (
                                <div className={s['checkbox-item']} key={index}>
                                    <Checkbox key={index} value={item?.id}>
                                        <div className={s['label']}>{item?.label}</div>
                                        <div className={s['type']}> {getCorrespondLabel(item?.template_id)}</div>
                                    </Checkbox>
                                </div>
                            ))}
                        </Checkbox.Group>
                    </div>

                    <Display show={!selected_value}>
                        <div className={s['btn-wrap']}>
                            <Display show={env !== envMap.pc}>
                                <GrtMobileButton disabled={!selected.length} size="small" color="primary" onClick={onSubmit}>
                                    确定
                                </GrtMobileButton>
                            </Display>
                            <Display show={env === envMap.pc}>
                                <GrtWebButton disabled={!selected.length} type="primary" onClick={onSubmit}>
                                    确定
                                </GrtWebButton>
                            </Display>
                        </div>
                    </Display>
                </Hide>
            </div>
            <Display show={isSubmit}>
                <div className={s['result-wrap']}>
                    <Result intelligent_qa_status={intelligent_qa_status} messageInfo={messageInfo}></Result>
                </div>
            </Display>
        </div>
    );
};
export default inject('store')(observer(AddInfo));
